// extracted by mini-css-extract-plugin
export default {"slide":"BOF9I","slide-active":"aKefl","card":"W1Yda","card-background":"ljaBR","innerSize--full":"IO7sz","card-active":"QVeWb"};